<template>
    <div class="skeleton-large">
        <div class="primary-content">
            <div class="left"/>
            <div class="right">
                <div class="top-row">
                    <div class="collect"/>
                    <div class="share"/>
                    <div class="expanded"/>
                    <div class="more"/>
                </div>
                <div class="separator"/>
                <div class="content">
                    <div class="avatar"/>
                    <div class="name"/>
                    <div class="numbers"/>
                    <div class="title"/>
                    <div class="prompt"/>
                    <div class="action1"/>
                    <div class="action2"/>
                </div>
            </div>
        </div>
        <div class="seprator"/>
        <div class="keywords">
            <div v-for="(item, index) of keywords" :key="index" class="item" :class="[item]"/>
        </div>
        <DetailPageSkeletonGridView/>
    </div>
</template>

<script setup>
const keywords = ['k1', 'k2', 'k3', 'k4', 'k5', 'k6', 'k7', 'k8', 'k9'];

</script>

<style scoped lang="scss">
.skeleton-large {
    margin: 21px auto 44px;
    padding: 0 40px;
    max-width: 1400px;
    .primary-content {
        height: 590px;
        width: 100%;
        display: flex;
        flex-direction: row;
        .left {
            width: 100%;
            height: 100%;
            margin-right: 22px;
            border-radius: 10px;
            background: #F4F5F6;
        }
        .right {
            min-width: 412px;
            height: 100%;
            border: 1px solid #f4f5f6;
            border-radius: 10px;
            .top-row {
                margin-top: 30px;
                display: flex;
                flex-direction: row;
                .collect {
                    margin-left: 30px;
                    width: 100px;
                    height: 44px;
                    background: #f4f5f6;
                    border-radius: 10px;
                }
                .share {
                    margin-left: 15px;
                    width: 100px;
                    height: 43px;
                    background: #f4f5f6;
                    border-radius: 10px;
                }
                .expanded {
                    flex: 1;
                }
                .more {
                    margin-right: 27px;
                    width: 44px;
                    height: 44px;
                    background: #f4f5f6;
                    border-radius: 10px;
                }
            }
            .separator {
                height: 1px;
                width: 100%;
                margin-top: 24px;
                background: rgba(0, 0, 0, 0.1);
            }
            .content {
                position: relative;
                width: 100%;
                height: 100%;
                .avatar {
                    width: 47px;
                    height: 47px;
                    background: #f4f5f6;
                    border-radius: 50%;
                    position: absolute;
                    left: 28px;
                    top: 19px;
                }
                .name {
                    width: 160px;
                    height: 22px;
                    background: #f4f5f6;
                    border-radius: 5px;
                    position: absolute;
                    left: 85px;
                    top: 19px;
                }
                .numbers {
                    width: 120px;
                    height: 18px;
                    background: #f4f5f6;
                    border-radius: 5px;
                    position: absolute;
                    left: 85px;
                    top: 48px;
                }
                .title {
                    width: 150px;
                    height: 22px;
                    background: #f4f5f6;
                    border-radius: 5px;
                    position: absolute;
                    left: 30px;
                    top: 86px;
                }
                .prompt {
                    width: 352px;
                    height: 218px;
                    background: #f4f5f6;
                    border-radius: 10px;
                    position: absolute;
                    left: 30px;
                    top: 120px;
                }
                .action1 {
                    width: 352px;
                    height: 44px;
                    background: #f4f5f6;
                    border-radius: 10px;
                    position: absolute;
                    left: 30px;
                    top: 358px;
                }
                .action2 {
                    width: 352px;
                    height: 44px;
                    background: #f4f5f6;
                    border-radius: 10px;
                    position: absolute;
                    left: 30px;
                    top: 418px;
                }
            }
        }
    }
    .seprator {
        margin-top: 49px;
        width: 100%;
        height: 1px;
        background: #f4f4f5;
    }
    .keywords::-webkit-scrollbar {
        display: none;
    }
    .keywords {
        margin-top: 66px;
        margin-bottom: 44px;
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        .item {
            flex-shrink: 0;
            white-space: nowrap;
            height: 43px;
            background: #f4f5f6;
            border-radius: 10px;
            margin-left: 12px;
            &:first-child {
                margin-left: 0px;
            }
            &.k1 {
                width: 124px;
            }
            &.k2 {
                width: 90px;
            }
            &.k3 {
                width: 110px;
            }
            &.k4 {
                width: 78px;
            }
            &.k5 {
                width: 72px;
            }
            &.k6 {
                width: 209px;
            }
            &.k7 {
                width: 116px;
            }
            &.k8 {
                width: 87px;
            }
            &.k9 {
                width: 100px;
            }
        }
    }
}
</style>
